
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinRespinOutroView} from "./HarelequinRespinOutroView";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {GameModeTransitionView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionView";
import {HarlequinBackground} from "../../background/HarlequinBackground";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";

export class HarlequinRespinOutroTransition extends GameModeTransitionControllerWithView {

    private _harleyView:HarlequinRespinOutroView;

    constructor(fromMode:string, toMode:string, view:GameModeTransitionView) {
        super(fromMode, toMode, view);
        this._harleyView = <HarlequinRespinOutroView> view;
    }

    protected hideKeypad():void {

    }

    protected showKeypad():void {

    }

    public start():void {
        HarlequinGameModuleConfig.CURRENT_MODE = this._toMode;

        if(this.isTriggeredThisSpin) {
            this._harleyView.prepare(<HarlequinParsedGameData> this._serverData);
            const tl:TimelineLite = new TimelineLite();

            if((<any>this._serverData).totalRespinWin > 0) {
                if(this._fromMode === "WILD_RESPIN" && this._toMode === "NORMAL") {
                    tl.add(() => SlotGame.keypad.setZeroBetSpinCounter(-1));
                }
                tl.add([
                    this._harleyView.getStartAnimation(() => {
                        this.prepareToEnterMode();
                    }, () => {
                        this.finish();
                    })

                ]);
            } else {
                if(this._fromMode === "WILD_RESPIN" && this._toMode === "NORMAL") {
                    tl.add([
                        () => SlotGame.keypad.setZeroBetSpinCounter(-1),
                        () => {
                            //debugger;
                            !HarlequinGameConfig.instance.WIN_BELOW_STAKE && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_OUTRO_FAIL);
                            //SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_OUTRO);
                            SlotGame.sound.fadeAmbience(0, 50);
                            SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.MAIN_GAME_AMBIANCE);
                            SlotGame.sound.fadeAmbience(1, 50);
                        }
                    ]);
                }
                if(this._fromMode === "WILD_RESPIN_FS" && this._toMode === "FREESPIN") {
                    tl.add([
                        () => {
                            //SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_OUTRO);
                            !HarlequinGameConfig.instance.WIN_BELOW_STAKE && SlotGame.sound.playEffect(HarlequinSoundConfig.instance.RESPIN_OUTRO_FAIL);
                            //SlotGame.sound.fadeAmbience(0, 50);
                            //SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.FREESPIN_AMBIANCE);
                            //SlotGame.sound.fadeAmbience(1, 50);
                        }
                    ]);
                }

                tl.add(() => this.finish());
            }
        }
    }

    protected finish():void {
        if(this._fromMode === "WILD_RESPIN" && this._toMode === "NORMAL") {

            //HarlequinGameModuleConfig.harlequinSignView.playSignSpine("respinToBaseGame");
            HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode);

            //HarlequinGameModuleConfig.harlequinSignView.playTextSpine("HarlequinRespinTextBaseGame");
            HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine();
            (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("basegame");
            //SlotGame.keypad.show();
        }
        if(this._fromMode === "WILD_RESPIN_FS" && this._toMode === "FREESPIN") {
            //SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.FREESPIN_AMBIANCE);
            //SlotGame.sound.fadeAmbience(1, 50);
            //HarlequinGameModuleConfig.harlequinSignView.playTextSpine("HarlequinRespinTextBaseGame");
            (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("bonusGame");
        }

        //HarlequinGameModuleConfig.harlequinSignView.setBonusSignAnimation("bonusSignIdle");
        HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode);

        super.finish();

    }

}